import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { createProvider } from './vue-apollo'
import './registerServiceWorker'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueInstaller from "vue-pwa-installer"
Vue.use(VueInstaller, { })

// import VueTagManager from "vue-tag-manager"
// Vue.use(VueTagManager, {
//   gtmId: 'GTM-N6C47SN'
// })

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-151972365-1',
  router
})

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000';
axios.defaults.baseURL = API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Auth'] = token;
}
Vue.use(VueAxios, axios)

import store from './store' // your vuex store 

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
import "vue-multiselect/dist/vue-multiselect.min.css";

Vue.config.productionTip = false

Vue.use(BootstrapVue);
require ('bootstrap/dist/css/bootstrap.css');
require ('bootstrap-vue/dist/bootstrap-vue.css');

require('@/assets/css/font-awesome.css');
require('@/assets/css/icon_fonts/elegant-icons.css');
require('@/assets/css/icon_fonts/pe-icons.css');
require('@/assets/css/icon_fonts/fontello-icons.css');
require('vue2-animate/dist/vue2-animate.min.css')
require('@/assets/css/custom.css');

import StarRating from 'vue-star-rating'
Vue.component('star-rating', StarRating);

import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog, { 
  okText: 'Confirmar',
  cancelText: 'Cancelar',
  html:true
});

import VueTextareaAutosize from 'vue-textarea-autosize'
Vue.use(VueTextareaAutosize)

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
Vue.use(VueToast,{position:'top-right'});

const moment = require('moment');
require('moment/locale/es');
Vue.use(require('vue-moment'), {moment});

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo)

import fullscreen from 'vue-fullscreen'
Vue.use(fullscreen)

import Meta from 'vue-meta';
Vue.use(Meta);

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app');
